module.exports = __webpack_public_path__ + "static/media/KF2_Logo.5b251745.png";